import React from "react";

/** Styled native select — filters and switchers. Native on purpose: it needs to work in a truck. */
export const Select: React.FC<React.SelectHTMLAttributes<HTMLSelectElement>> = ({ className = "", children, ...rest }) => (
    <select
        className={`min-h-9 rounded-[10px] border border-[var(--line-2)] bg-[var(--surface)] px-2.5 text-[12.5px] font-medium ${className}`}
        {...rest}
    >
        {children}
    </select>
);
